export const SEARCH_OBJECT_TYPE = {
    noResults: 'no_results',
    products: 'products',
    product: 'product',
    recommendations: 'recommendations',
    brandwall: 'brandwall',
    category: 'category',
    page: 'page',
};
